const ENMeasureUnits = {
	"Adicionar unidade de medida": "Add measure unit",
	"Deseja realmente excluir a unidade de medida": "Do you really want to delete the measure unit",
	"Erro ao adicionar unidade de medida": "Error on adding measure unit",
	"Erro ao alterar unidade de medida": "Error on changing measure unit",
	"Erro ao excluir unidade de medida": "Error on deleting measure unit",
	"Exclusão da unidade de medida": "Delete measure unit",
	"Descrição da unidade de medida é requerida": "Measure unit's description is required",
	"Unidade de medida adicionada com sucesso": "Measure unit successfully added",
	"Unidade de medida alterada com sucesso": "Measure unit successfully changed",
	"Unidade de medida excluída com sucesso": "Measure unit successfully deleted",
	"Nova unidade de medida": "New measure unit",
	"Unidades de medida":"Measure unit"
};

export default ENMeasureUnits;
 
